import { RunsheetConfigType } from "../../../../context/DiaryContext";
import { setRunsheetConfigToStorage } from "../../../../utils/localStorage/runsheetConfigStorage";

export const runsheetConfigOptions = [
  {
    key: "showTimeDividers" as keyof RunsheetConfigType,
    label: "Show Time Dividers"
  }
];

export const updateRunsheetConfig = async ({
  update,
  runsheetConfig,
  setDiaryContext
}: {
  update: Partial<RunsheetConfigType>;
  runsheetConfig: RunsheetConfigType;
  setDiaryContext: (context: any) => void;
}) => {
  const updatedConfig = { ...runsheetConfig, ...update };
  setDiaryContext({ runsheetConfig: updatedConfig });
  await setRunsheetConfigToStorage(updatedConfig);
};
